module.exports = __webpack_public_path__ + "img/lsb.2a19ac9a.jpg";